export default "__VITE_ASSET__D0UA_E$6__"